// extracted by mini-css-extract-plugin
module.exports = {"molecule__action-notice-apps-container":"styles_molecule__action-notice-apps-container__YitVp","favorite-card-app":"styles_favorite-card-app__iSjJ4"};